/** @jsx CanvaSX */
import { CanvaSX } from '@lib/canvasx/canvasx';
import { Rect, type RectProps } from '@lib/canvasx/components/Rect';
import { canvasCssValue } from '@lib/canvasx/util';
import { type FieldContentsData } from '../../shared-types';

export interface ProgressFieldProps {
  backgroundColor?: RectProps['fill'];
  color?: RectProps['fill'];
  height?: number;
  progress: number;
  width?: number;
  contents: FieldContentsData;
  fieldId: RecordId;
}

export const ProgressField: CanvaSXFC<ProgressFieldProps> = function ({
  backgroundColor = canvasCssValue(
    'var(--theme-container-background)',
    'rgb(247, 247, 247)'
  ),
  color = canvasCssValue('--theme-green-border', 'rgb(123, 186, 52)'),
  height = 8,
  progress,
  width = 70,
}) {
  const border = canvasCssValue(
    'var(--theme-secondary-border)',
    'rgb(205, 205, 205)'
  );

  const borderRadius = height / 2;
  return (
    <Rect
      width={width}
      height={height}
      fill={backgroundColor}
      borderRadius={borderRadius}
      border={border}
    >
      <Rect
        x={0.5}
        y={0.5}
        width={(width * progress) / 100}
        height={height - 1}
        fill={color}
        borderRadius={borderRadius}
      />
    </Rect>
  );
};
